import React from "react";
import { useParams } from "react-router-dom";

import CmsAddBlog from "../cms/AddBlog";

const EditBlog = () => {
  const { blogId = "" } = useParams();

  return <CmsAddBlog motherMenu="Blogs" forcedBlogId={blogId} />;
};

export default EditBlog;
